export const LOGO_URL = "/logo-4c.png?v=3";
export const VERSO_URL = "/verso-carte.png";

export const PURCHASE_LINKS = [
  { key: "amazon_url", label: "ACHETER SUR AMAZON" },
  { key: "kindle_url", label: "VERSION KINDLE" },
  { key: "pdf_url", label: "VERSION PDF" },
  { key: "ebook_url", label: "VERSION EBOOK" },
  { key: "other_url", label: "AUTRE VERSION" },
];

export const COLORS = {
  vert: "#385E3A",
  rouge: "#A63B36",
  bleu: "#2E5B7F",
  or: "#C9A24B",
  anthracite: "#1F2A24",
  beige: "#F8F5EE",
  sable: "#E8DCC4",
  ivoire: "#F6F2E9",
  blanc: "#FFFFFF",
};

export const DIMENSIONS = [
  {
    key: "corps",
    label: "CORPS",
    color: COLORS.vert,
    tagline: "Vitalité • Équilibre • Santé",
    points: ["Respiration", "Sensations", "Mouvement", "Présence corporelle"],
    idea: "Revenir dans le corps pour ne pas vivre uniquement dans la tête.",
  },
  {
    key: "coeur",
    label: "CŒUR",
    color: COLORS.rouge,
    tagline: "Amour • Émotions • Relations",
    points: ["Émotions", "Besoins", "Relations", "Vécu intérieur"],
    idea: "Considérer l'émotion comme une information plutôt que comme un ennemi.",
  },
  {
    key: "cerveau",
    label: "CERVEAU",
    color: COLORS.bleu,
    tagline: "Clarté • Apprentissage • Créativité",
    points: ["Pensée", "Réflexion", "Discernement", "Choix"],
    idea: "Créer un espace entre l'impulsion et l'action.",
  },
  {
    key: "conscience",
    label: "CONSCIENCE",
    color: COLORS.or,
    tagline: "Présence • Alignement • Sens",
    points: ["Observation", "Présence", "Intention", "Cohérence"],
    idea: "Relier et orienter les trois autres dimensions autour d'une intention claire.",
  },
];

export const RITUAL = ["RESPIRER", "RESSENTIR", "OBSERVER", "S'ALIGNER"];

export const PRINCIPLES = [
  { title: "FLUIDITÉ", text: "Comme l'eau." },
  { title: "FLEXIBILITÉ", text: "Comme le bois." },
  { title: "WU WEI", text: "Agir sans forcer." },
  { title: "INTENTION JUSTE", text: "Privilégier l'intention plutôt que la maîtrise obsessionnelle du résultat." },
  { title: "EXPÉRIMENTATION", text: "Tester, observer et adapter." },
];

// accent color cycling for carnet covers
export const CARNET_ACCENTS = [
  COLORS.vert,
  COLORS.or,
  COLORS.bleu,
  COLORS.rouge,
];

// Liens d'achat du livre
export const AMAZON_PRINT_URL = "https://www.amazon.fr/dp/B0HLW813X4";
export const AMAZON_EBOOK_URL = "https://www.amazon.fr/dp/B0HLW5L8HV";

export function categoryColor(cat) {
  const map = {
    CORPS: COLORS.vert,
    "CŒUR": COLORS.rouge,
    CERVEAU: COLORS.bleu,
    CONSCIENCE: COLORS.or,
    ACTION: COLORS.anthracite,
    "INTÉGRATION": COLORS.or,
  };
  return map[cat] || COLORS.vert;
}
